import React, { useEffect } from "react"
import { Select, Typography } from "antd"
import { useConfig } from "../../contexts/ConfigContext"
import { useCompany } from "../../contexts/CompanyContext"
import { useBotAdmin } from "../../contexts/BotAdminContext"
import { useBots } from "../../hooks/useWpbot"
import useAuth from "../../hooks/useAuth"
import { TBot } from "../../models/wpbotModel"

/**
 * Selector de bot compartido por las vistas operativas del módulo
 * (tools, contactos, conversaciones). La selección persiste en
 * BotAdminContext al navegar entre vistas.
 */
function BotSelector(){
  const { config } = useConfig()
  const { company } = useCompany()
  const { botAdmin, updateBotAdmin } = useBotAdmin()
  const { tokenData } = useAuth.useToken('authCsrfToken', config.session, config.key)
  const { data, isLoading } = useBots(tokenData, { company: company.current?.uid })

  const bots: TBot[] = React.useMemo(
    () => (data?.status === 200 ? (data?.bots || []) : []),
    [data]
  )

  // Si no hay bot seleccionado (o el seleccionado ya no existe), tomar el primero
  useEffect(() => {
    if (bots.length && !bots.some((b) => b.id === botAdmin.selectedBotId)) {
      updateBotAdmin({ selectedBotId: bots[0].id })
    }
  }, [bots, botAdmin.selectedBotId, updateBotAdmin])

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Typography.Text strong>Bot:</Typography.Text>
      <Select
        style={{ minWidth: 260 }}
        loading={isLoading}
        placeholder="Selecciona un bot"
        value={botAdmin.selectedBotId || undefined}
        onChange={(value) => updateBotAdmin({ selectedBotId: value })}
        options={bots.map((bot) => ({
          value: bot.id,
          label: `${bot.display_name} (${bot.phone_number})`,
        }))}
        notFoundContent={isLoading ? "Cargando..." : "No hay bots configurados"}
      />
    </div>
  )
}

export default BotSelector
